import { lazy } from 'react';

export const lazyWithDelay = (importFunc, delay = 300) => {
	return lazy(() => {
		return Promise.all([importFunc(), new Promise((resolve) => setTimeout(resolve, delay))]).then(
			([moduleExports]) => moduleExports,
		);
	});
};
